export default __webpack_public_path__ + "static/media/ThermocoupleImg.d38be5c5.jpg";